import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import formatTimestamp from '../../common/formatTimestamp';
import InfoText from '../../common/InfoText';
import DescriptionBox from '../common/DescriptionBox';
import {UpdateJob} from '../types';
import '../types';
import './JobDetailsDetails.less';
import useGetUserByAccountNumber from '../hooks/useGetUserByAccountNumber';
import {extractEmail} from '../utils';
type Props = {
	job: UpdateJob;
};
const infoTranslation = {
	id: 'updatejobs.details.statusInfo',
	defaultValue:
		'By default, updates will be carried out on the latest execution date. Subtenants can schedule the job to be executed at an earlier date in their workspaces.'
};

const JobDetailsDetails = ({job: {id, status, latestExecutionDate, createdAt, createdBy, description}}: Props) => {
	const {loading, user} = useGetUserByAccountNumber(createdBy);
	const userEmail = extractEmail(user);
	return (
		<div className="di job-details-details">
			<h2 className="di header dividing">
				<Trans i18nKey="updatejobs.details.form">Job Details</Trans>
			</h2>
			<SpinnerContainer show={loading}>
				<div className="di job-details">
					<div className="field job-id">
						<label>
							<Trans i18nKey="updatejobs.details.jobId">Update Job Id</Trans>
						</label>
						<div>{id}</div>
					</div>
					<div className="field status">
						<label>
							<Trans i18nKey="updatejobs.details.status">Status</Trans>
						</label>
						<div>{status}</div>
					</div>
					<div className="field latest-execution-date">
						<label>
							<Trans i18nKey="updatejobs.details.latestExecutionDate">Latest Execution date</Trans>
						</label>
						<InfoText direction="right" bubble={infoTranslation}>
							{formatTimestamp(latestExecutionDate)}
						</InfoText>
					</div>
					<div className="field created-at-date">
						<label>
							<Trans i18nKey="updatejobs.details.createdAtDate">Job created on</Trans>
						</label>
						<div>{formatTimestamp(createdAt)}</div>
					</div>
					{user && (
						<div className="field created-by">
							<label>
								<Trans i18nKey="updatejobs.details.createdBy">Job created by</Trans>
							</label>
							<div>{userEmail ? <a href={`mailto:${userEmail}`}>{userEmail}</a> : user.name}</div>
						</div>
					)}
					{description && <DescriptionBox description={description} showDefault={false} />}
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default JobDetailsDetails;
